import React, { useState } from "react";
import { Pressable, Text, View } from "react-native";
import styles from "../SustainQueueScreen.style";
import { TicketStatus } from "../../../store/slices/ticketingPortalSlice";
import { SustainQueueStatusPill } from "../hooks/useSustainQueueListing";

type Props = {
  activeStatus: "all" | TicketStatus;
  statusPills: SustainQueueStatusPill[];
  statusCounts: Record<string, number>;
  onStatusChange: (value: "all" | TicketStatus) => void;
  isDark?: boolean;
};

const SustainQueueStatusSummary: React.FC<Props> = ({
  activeStatus,
  statusPills,
  statusCounts,
  onStatusChange,
  isDark,
}) => {
  const [hoveredKey, setHoveredKey] = useState<string | null>(null);

  return (
    <View style={[styles.statusSummary, isDark && { backgroundColor: "#202020" }]}>
      {statusPills.map((pill) => {
        const active = activeStatus === pill.key;
        const hovered = hoveredKey === pill.key;
        return (
          <Pressable
            key={pill.key}
            // @ts-ignore — onMouseEnter/onMouseLeave are valid on React Native Web
            onMouseEnter={() => setHoveredKey(pill.key)}
            onMouseLeave={() => setHoveredKey(null)}
            style={({ pressed }) => [
              styles.statusPill,
              isDark && !active && { backgroundColor: "#2B2B2B" },
              active ? styles.statusPillActive : null,
              !active && hovered ? styles.statusPillHovered : null,
              !active && hovered && isDark ? { backgroundColor: "#363636" } : null,
              pressed ? styles.statusPillPressed : null,
            ]}
            onPress={() => onStatusChange(pill.key)}
          >
            {pill.dotColor ? (
              <View style={[styles.statusDot, { backgroundColor: pill.dotColor }, active ? styles.statusDotActive : null]} />
            ) : null}
            <Text style={[styles.statusPillLabel, isDark && !active && { color: "#B0B0B0" }, active ? styles.statusPillLabelActive : null]}>{pill.label}</Text>
            <Text style={[styles.statusPillCount, isDark && !active && { color: "#B0B0B0", backgroundColor: "rgba(255,255,255,0.08)" }, active ? styles.statusPillCountActive : null]}>{statusCounts[pill.key] ?? 0}</Text>
          </Pressable>
        );
      })}
    </View>
  );
};

export default SustainQueueStatusSummary;
